module.exports = {
  "dof-image": {
    "width": "90",
    "height": "24",
    "marginRight": "6"
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-3abbccfe!./~/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/dof-rich-text/dof-rich-text-icon.vue
// module id = 458
// module chunks = 0 1